import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { HashRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import store from './redux/store.js';
import './index.css'
import Bajas from './pages/Bajas.jsx';


ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter>
        {/* <BrowserRouter> */}
        {
          !window.location.href.includes("bajas") ?
            <App />
            :
            <Bajas />
        }
        {/* </BrowserRouter> */}
      </HashRouter>
    </Provider>
  </React.StrictMode >
);
